import {Component, EventEmitter, Input, Output,} from '@angular/core';
import {ParcelHistoryRow} from "../../../../open-api-generated/models/parcel-history-row";
import {ToastsService} from "../../../../services/toasts.service";
import {ParcelService} from "../../../../open-api-generated/services/parcel.service";

declare var UIkit: any;

@Component({
  selector: 'app-parcel-history-view',
  templateUrl: './parcel-history-view.component.html',
  styleUrls: ['./parcel-history-view.component.scss']
})
export class ParcelHistoryViewComponent {
  @Input('language') language: string = 'pl';
  @Input('parcelId') parcelId: number;
  @Input('isAdmin') isAdmin: boolean = false;
  @Input('history') history: ParcelHistoryRow[] = null;
  @Output('onStatusChangedEvent') onStatusChangedEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private toastsService: ToastsService,
    private parcelService: ParcelService,
  ) {
  }

  handleStatusChangedEvent(): void {
    this.onStatusChangedEvent.emit();
  }

  delete(id: number): void {
    const promised: Promise<boolean> = this.toastsService.showConfirmModal();
    promised.then(
      (runAction: boolean): void => {
        if (runAction) {
          this.parcelService.appV2ParcelHistoryDelete({
            body: {
              id,
            },
          }).subscribe(
            (response: any)=> {
              this.toastsService.showMessage('Pomyślnie usunięto status!', 's');
              this.onStatusChangedEvent.emit();
            }
          );
        }
      }
    );
  }
}
